import { render, staticRenderFns } from "./modal_show.vue?vue&type=template&id=a8be2222&scoped=true&"
import script from "./modal_show.vue?vue&type=script&lang=js&"
export * from "./modal_show.vue?vue&type=script&lang=js&"
import style0 from "./modal_show.vue?vue&type=style&index=0&id=a8be2222&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8be2222",
  null
  
)

export default component.exports